import z from 'zod';
import {tradeTagDbSchema} from './tradeTagDbSchema';

export const tradeTagWriteSchema = tradeTagDbSchema;

export type TradeTagWrite = z.infer<typeof tradeTagWriteSchema>;
